import { h } from 'preact'
import IdeaView from './IdeaView'

interface Props {
  isGuest: boolean,
  ideas: Array<any>,
  currentUserId: number
}

const IdeasOverview = ({ isGuest, ideas, currentUserId }: Props) => (
  <div className='ideas-overview-wrapper'>
    <div className='sitewidth text-center'>
      <h1 className='ideas-overview-wrapper-title'>Ideas</h1>
    </div>
    <br />
    <div className='ideas-overview'>
      {
        ideas.map(idea => <IdeaView
          {...idea}
          isGuest={isGuest}
          currentUserId={currentUserId}
        />)
      }
    </div>
  </div>
)

export default IdeasOverview
